'use client'

import { useEffect } from 'react'
import { reportClientError } from '@/lib/reliability/client-errors'
import { reloadOnceForChunkError } from '@/lib/reliability/chunk-reload'

/**
 * The root layout itself failed, so nothing it provides (fonts, styles,
 * locale) can be assumed: plain markup, inline styles, three languages.
 */
export default function GlobalError({ error }: { error: Error & { digest?: string } }) {
  useEffect(() => {
    if (reloadOnceForChunkError(error)) return
    console.error('[root-error]', error)
    reportClientError(error)
  }, [error])

  return (
    <html lang="en">
      <body style={{ margin: 0, minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'system-ui, sans-serif', textAlign: 'center', padding: 32 }}>
        <div>
          <h1 style={{ fontSize: 18, fontWeight: 600, margin: '0 0 8px' }}>Something went wrong · 發生錯誤 · 发生错误</h1>
          <p style={{ fontSize: 14, color: '#6b7280', margin: '0 0 24px' }}>
            Please reload the page. · 請重新載入頁面。 · 请重新加载页面。
            {error.digest && <span style={{ display: 'block', marginTop: 8, fontSize: 12, fontFamily: 'monospace' }}>{error.digest}</span>}
          </p>
          <button
            type="button"
            onClick={() => window.location.reload()}
            style={{ padding: '10px 16px', borderRadius: 12, border: 0, background: '#4f46e5', color: '#fff', fontSize: 14, fontWeight: 500, cursor: 'pointer' }}
          >
            Reload · 重新載入 · 重新加载
          </button>
        </div>
      </body>
    </html>
  )
}
